<section class="flex items-center gap-8 rounded-t-xl bg-neutrals-white px-4 py-2.5 shadow">
  <div class="flex gap-4">
    @if (daySelectable()) {
      <article class="flex items-center gap-1 rounded-md border border-neutrals-grey-02 px-3 py-1">
        <button type="button" [class.cursor-not-allowed!]="!canGoPrevious()" [disabled]="!canGoPrevious()" (click)="previousDay()">
          <img [src]="images.arrowLeft" alt="previousDay" class="h-3 w-3" [class.filter-neutrals-grey-02]="!canGoPrevious()" [class.filter-primary-purple-light]="canGoPrevious()" />
        </button>
        <app-calendar
          class="relative w-24"
          [id]="'positions-player-day'"
          [title]="'positions-player-day'"
          [value]="calendarDay()"
          [minDate]="calendarMinDay()"
          [maxDate]="calendarMaxDay()"
          [showOnTop]="true"
          [showYear]="false"
          [compact]="true"
          (change)="selectCalendarDay($event)"
        />
        <button type="button" [class.cursor-not-allowed!]="!canGoNext()" [disabled]="!canGoNext()" (click)="nextDay()">
          <img [src]="images.arrowRight" alt="nextDay" class="h-3 w-3" [class.filter-neutrals-grey-02]="!canGoNext()" [class.filter-primary-purple-light]="canGoNext()" />
        </button>
      </article>
    }
    <input type="time" class="rounded-md border border-neutrals-grey-02 bg-neutrals-white px-3 py-1 font-semibold tabular-nums [&::-webkit-calendar-picker-indicator]:hidden" [value]="currentTime() | date: 'HH:mm'" (change)="setTime($event)" />
  </div>
  <button id="playButton" type="button" class="btn btn-circle btn-sm border-none bg-primary-purple h-10 w-10" (click)="togglePlay()" [tooltip]="literalService.get(playing() ? 'trips.positions.player.pause' : 'trips.positions.player.play', true)">
    <img [src]="playing() ? images.pause : images.play" [alt]="playing() ? 'pause' : 'play'" class="h-5 w-5 filter-neutrals-white" />
  </button>
  <article class="relative flex-1">
    <div class="relative mx-3 h-7 mb-2">
      @for (tick of ticks(); track tick.percent) {
        <div class="absolute bottom-0 flex -translate-x-1/2 flex-col items-center" [style.left.%]="tick.percent">
          @if (tick.label) {
            <span class="text-xs text-neutrals-grey-04 font-semibold">{{ tick.label }}</span>
          }
          <div class="w-px bg-neutrals-grey-03" [ngClass]="tick.label ? 'h-2' : 'h-1'"></div>
        </div>
      }
    </div>
    <input type="range" class="positions-range range range-md w-full text-primary-purple-light" [style.--available]="availableFraction()" [class.whole-day-available]="!isToday()" [style.--progress]="progressFraction()" [min]="rangeStartMinute()" [max]="rangeEndMinute()" step="1" [value]="currentMinute()" (input)="seek($event)" />
    @if (atNow()) {
      <div class="pointer-events-none absolute inset-x-3 bottom-0 h-6">
        <span class="absolute bottom-full mb-1 -translate-x-1/2 rounded bg-primary-purple-light px-1.5 text-[9px] font-extrabold text-neutrals-white uppercase" [style.left.%]="progressFraction() * 100">
          {{ literalService.get('trips.positions.player.now', true) }}
        </span>
      </div>
    }
  </article>
  <article class="flex gap-0.5 rounded-full border border-neutrals-grey-02 py-1 px-2">
    @for (option of speeds; track option) {
      <button type="button" class="btn btn-xs font-extrabold" [ngClass]="option === speed() ? 'rounded-full border border-primary-purple-light! text-primary-purple-light bg-primary-purple-light-2': 'bg-transparent border-none text-neutrals-grey-04'" (click)="speed.set(option)">{{ option }}x</button>
    }
  </article>
</section>
